import { RootState } from "core-integration/src/store";
import { getActiveOrProposedTeamChipName } from "core-integration/src/store/chips/reducers";
import { getElement } from "core-integration/src/store/elements/reducers";
import { getNextEvent } from "core-integration/src/store/events/reducers";
import { getFixturesByEvent } from "core-integration/src/store/fixtures/reducers";
import { IPickProposed } from "core-integration/src/store/my-team/types";
import { size } from "polished";
import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import NoFixtureHyphen from "../../img/icons/no-fixture-hyphen.svg?react";
import { integerToDecimal } from "../../utils/decimal";
import { getNextElementFixtures, getOpponentTeam } from "../../utils/fixtures";
import { integerDivide } from "../../utils/points";
import Badge from "../Badge";
import ElementDialogButton from "../ElementDialogButton";
import ElementInTable from "../ElementInTable";
import { ElementCell, ElementRow } from "../ElementTable";
import TeamElementIcon from "./TeamElementIcon";

const NoFixture = styled(NoFixtureHyphen)`
  ${size(16)}
`;

const StyledTableCell = styled.td`
  text-align: center;
`;

interface IMyTeamRowProps {
  pick: IPickProposed;
  elementId: number;
  renderElementMenu: (index: number) => void;
}

const MyTeamRow: React.FC<IMyTeamRowProps> = ({
  pick,
  elementId,
  renderElementMenu,
}) => {
  const chipInPlayName = useSelector(getActiveOrProposedTeamChipName);
  const element = useSelector((state: RootState) =>
    getElement(state, elementId),
  );

  const fixturesByEvent = useSelector(getFixturesByEvent);
  const nextEvent = useSelector(getNextEvent);
  const neededFixtures = 3;
  const elementFixtures =
    element &&
    getNextElementFixtures(nextEvent, neededFixtures, fixturesByEvent, element);

  if (!element) {
    return null;
  }

  return (
    <ElementRow variant={pick.subStatus}>
      <td>
        <ElementDialogButton elementId={element.id} variant="list" />
      </td>
      <td>
        <TeamElementIcon pick={pick} chipName={chipInPlayName} />
      </td>
      <ElementCell>
        <ElementInTable
          renderElementMenu={() => renderElementMenu(pick.element)}
          elementId={element.id}
        />
      </ElementCell>
      <td>{integerToDecimal(Number(element.form), 10)}</td>
      <td>{integerDivide(element.event_points, 10)}</td>
      <td>{integerDivide(element.total_points, 10)}</td>
      {elementFixtures?.map((fixture) =>
        fixture.code ? (
          <StyledTableCell key={fixture.code}>
            <Badge
              teamId={getOpponentTeam(element.team, fixture)}
              width="30px"
              isPresentation={true}
            />
          </StyledTableCell>
        ) : (
          <StyledTableCell key={fixture.event!}>
            <NoFixture />
          </StyledTableCell>
        ),
      )}
    </ElementRow>
  );
};

export default MyTeamRow;
